
class ProgressBarWidget {
    private $elem: JQuery;
    private max: number;
    private value: number;

    private $bar: JQuery;
    private $progress: JQuery;
    private $handle: JQuery;

    constructor($elem: JQuery) {
        this.$elem = $elem;
        this.value = 0;
        this.max = 0;

        $elem.addClass("progressBar");
        this.$bar = $('<div class="bar">');
        this.$progress = $('<div class="progress">');
        this.$handle = $('<div class="handle">');

        var $handleContainer = $('<div class="handleContainer">');
        $handleContainer.append(this.$handle);

        this.$bar.append(this.$progress);
        $handleContainer.append(this.$handle);

        $elem.append(this.$bar);
        $elem.append($handleContainer);
        $elem.data('_progressBar', this);
    }

    private _getSelf(): ProgressBarWidget|undefined {
        return this.$elem.data('_progressBar');
    }

    getMax(): number {
        return this._getSelf().max;
    }
    getValue(): number {
        return this._getSelf().value;
    }

    setMax(maxValue: number) {
        this._update(undefined, maxValue);
    }
    setValue(value: number) {
        this._update(value);
    }

    private _update(value?: number, maxValue?: number) {
        let self = this._getSelf();
        let percent = -1;

        if (self === undefined) return;
        if (value !== undefined) self.value = value;
        if (maxValue !== undefined) self.max = maxValue;

        var progress = self.value/self.max*100;
        if (self.max > 0) percent = Math.floor(progress);
        if (percent >= 0) {
            self.$progress.css('width', progress+"%");
            self.$handle.css('left', progress+'%');
            self.$elem.removeClass('noDuration');
        }
        else self.$elem.addClass('noDuration');
    }
}

export function ProgressBar(selector: string): ProgressBarWidget {
    // return existing ProgressBarWidget if it exists
    var $elem = $(selector);
    var rc = $elem.data('_progressBar');
    if (rc) return rc;

    return new ProgressBarWidget($elem);
}

class TrackInfoWidget {
    private $elem: JQuery;

    private $subElem: JQuery;

    private currentPos: number;
    private currentStep: number;
    private interval?: number; // timer

    constructor($elem: JQuery) {
        this.$elem = $elem;
        $elem.addClass("trackInfo");

        this.currentPos = -10;
        this.currentStep = -2;

        this.$subElem = $('<div class="trackText">')
        $elem.append(this.$subElem);
        $elem.data('_trackInfo', this);

    }

    setText(text: string) {
        this.$subElem.text(text);
        this._sizeChanged();
    }

    private _getContentWidth(): number {
        var rc = this.$subElem.width();
        if (rc == undefined) throw "TrackInfo: missing content width";
        return rc;
    }

    private _getViewportWidth(): number {
        var rc = this.$elem.width();
        if (rc == undefined) throw "TrackInfo: missing viewport width";
        return rc;
    }

    private _move() {
        this.currentPos += this.currentStep;
        let pos = this.currentPos;
        var minPos = this._getViewportWidth() - this._getContentWidth();

        // check whether we need to revert our direction
        if (this.currentStep < 0) {
            // currently moving left
            if (pos < minPos - 30) {
                // revert direction
                this.currentStep *= -1;
            }
        }
        else {
            // currently moving right
            if (pos >= 30) {
                // revert direction
                this.currentStep *= -1;
            }
        }

        // this causes the div to stop instead of overshooting
        if (pos < minPos) pos = minPos;
        if (pos > 0) pos = 0;

        this._moveToPos(pos);
    }

    private _moveToPos(pos: number) {
        this.$elem.scrollLeft(-1*pos);
    }

    private _sizeChanged() {
        if (this.interval != undefined) clearInterval(this.interval);

        if (this._getViewportWidth() < this._getContentWidth()) {
            // we're too small => scroll
            if (!this.currentPos) this.currentPos = 0;
            if (!this.currentStep) this.currentStep = -2;
            var self = this;
            this.interval = setInterval(function() {self._move();}, 40);
        }
        else {
            // enough size => just display it at pos 0,0
            this.currentPos = 0;
        }
        this._moveToPos(this.currentPos);
    }
}

export function TrackInfo(selector: JQuery): TrackInfoWidget {
	let $elem = $(selector);
    var rc = $elem.data("_trackInfo");
    if (rc) return rc;

    // set up container (for all matching elements)
    $elem.each(function(_i, elem) {
        let $elem = $(elem);
        new TrackInfoWidget($elem);
    });

    return $elem.data('_trackInfo'); // returns the first matching object
}
